import {createRouter, createWebHistory} from 'vue-router';
import Home from './components/pages/Home.vue';
import About from './components/pages/About.vue';
import Events from './components/pages/Events.vue';
import Resources from './components/pages/Resources.vue';
import Donate from './components/pages/Donate.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
      { path: '/',redirect: '/home'},
      { path: '/home', name: 'home', component: Home},
      { path: '/about', name: 'about', component: About},
      { path: '/events', name: 'events', component: Events},
      { path: '/resources', name: 'resources', component: Resources},
      { path: '/donate', name: 'donate', component: Donate}, 
  ],
  scrollBehavior(to, from, savedPosition) {
    if(savedPosition){
      return savedPosition;
    } else {
      // // Otherwise, try to retrieve from sessionStorage
      // const storedPosition = sessionStorage.getItem(`scrollPos_${from.path}`);
      // if (storedPosition) {
      //     return JSON.parse(storedPosition);
      // }
      // // Default to top of the page if no saved position or stored position
      return { top: 0, left: 0 };       
    }
  }
});

// router.beforeEach((to, from, next) => {
//     if (window.scrollY !== undefined) {
//         sessionStorage.setItem(`scrollPos_${from.path}`, JSON.stringify({ top: window.scrollY, left: window.scrollX }));
//     }
//     next();
// });

export default router;